<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-row>
                <v-col cols="12" class="py-0">
                    <switch-button
                        :value="emailServiceEnabled"
                        :label="$t('Email server')"
                        @change="handleInput('emailServiceEnabled', $event ? 1 : 0)"
                    />
                </v-col>
                <v-col cols="12">
                    <v-row
                        v-if="emailServiceEnabled"
                        no-gutters
                        class="pl-12"
                    >
                        <v-col
                            class="pl-1"
                            cols="12"
                        >
                            <v-row dense>
                                <v-col cols="4">
                                    <v-select
                                        :value="vendor"
                                        :label="$t('Email provider')"
                                        :items="vendors"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        offset-y
                                        return-object
                                        hide-details
                                        @input="handleInput('vendor', $event)"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        :value="host"
                                        :label="$t('Host')"
                                        outlined
                                        hide-details
                                        @input="handleInput('host', $event)"
                                    />
                                </v-col>
                                <v-col
                                    cols="2"
                                >
                                    <v-text-field
                                        :value="port"
                                        :label="$t('Port')"
                                        outlined
                                        hide-details
                                        @input="handleInput('port', $event)"
                                    />
                                </v-col>
                                <v-col
                                    cols="2"
                                >
                                    <v-text-field
                                        :value="security"
                                        :label="$t('Security')"
                                        outlined
                                        hide-details
                                        @input="handleInput('security', $event)"
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col
                                    cols="4"
                                >
                                    <v-text-field
                                        :value="fromName"
                                        :label="$t('Sender name')"
                                        outlined
                                        hide-details
                                        @input="handleInput('fromName', $event)"
                                    />
                                </v-col>
                                <v-col
                                    cols="4"
                                >
                                    <v-text-field
                                        :value="username"
                                        :label="$t('Sender email') + ' / ' + $t('Username')"
                                        hide-details
                                        outlined
                                        @input="handleInput('username', $event)"
                                    />
                                </v-col>
                                <v-col
                                    cols="4"
                                >
                                    <v-text-field
                                        :value="password"
                                        :label="$t('Password')"
                                        :append-icon="password_type === 'password' ? 'mdi-eye-off' : 'mdi-eye'"
                                        :error-messages="passwordError"
                                        :type="password_type"
                                        outlined
                                        hide-details
                                        @input="handleInput('password', $event)"
                                        @click:append="changeType()"
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="3">
                                    <OutlineButton
                                        :title="$t('Test connection')"
                                        @click="onSendTestEmail"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>


<script>
import { $t } from "@/i18n";
import OutlineButton from "@/components/Buttons/OutlineButton";
import { ref } from "@vue/composition-api";

export default {
    name: "BillingDialogEmailSettingsInputs",
    components: {
        OutlineButton
    },
    props: {
        vendors: {
            type: Array,
            default: () => []
        },
        emailServiceEnabled: {
            type: Number,
            default: 0
        },
        vendor: {
            type: String,
            default: ''
        },
        host: {
            type: String,
            default: ''
        },
        port: {
            type: [Number, String],
            default: 0
        },
        security: {
            type: String,
            default: ''
        },
        username: {
            type: String,
            default: ''
        },
        password: {
            type: String,
            default: ''
        },
        passwordError: {
          type: String,
          default: null
        },
        fromEmail: {
            type: String,
            default: ''
        },
        fromName: {
            type: String,
            default: ''
        }
    },
    setup(props, ctx) {

        const onSelectVendor = function(value){
            ctx.emit(`select_vendor`, value)
        }

        const handleInput = function(name, value){
            if(name === 'password') ctx.emit('update:passwordError', null)
            ctx.emit(`update:${name}`, value)
        }

        const onSendTestEmail = function(){
            ctx.emit('send_test_email')
        }

        const password_type = ref('password')
        const changeType = function() {
            if (password_type.value === "password") password_type.value = "text";
            else password_type.value = "password";
        }

        return {
            handleInput,
            onSelectVendor,
            onSendTestEmail,
            changeType,
            password_type,
        };
    }
};
</script>
